import React from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";

const Restauranttime = (props) => {
  const { openRestTimeModal, setOpenRestTime } = props;
  return (
    <Modal
      show={openRestTimeModal.state}
      onHide={() => {
        setOpenRestTime(false);
      }}
      centered
      className="logoutmodal center-close-icon"
    >
      <Modal.Header closeButton></Modal.Header>
      <div className="bodyModal">
        <h5 className="head5 text-center">Store Hours</h5>
        <div className="time_modbox  mt-4">
          {!!openRestTimeModal?.data?.length
            ? openRestTimeModal?.data?.map((item) => (
              <div
                key={item.day}
                className="d-flex justify-content-between mb-2"
              >
                <div className="col-left">{item.day}</div>
                <div className="col-right">
                  {moment(item?.from_time, " h:mm a").format(" h:mm A")} -
                  {moment(item?.to_time, " h:mm a").format(" h:mm A")}
                </div>
              </div>
            ))
            : "No data found"}
        </div>
      </div>
    </Modal>
  );
};

export default Restauranttime;
